import React from "react";
import { Dialog, DialogTitle, List, ListItem, ListItemButton, ListItemText, Typography } from "@mui/material";
import Service from "../../../../util/Service";
import SearchField from "../../../util/SearchField";


export default function APICodeDialog(props) {
    const { onClose, open, code, setCode } = props;
    const [listAPI, setListAPI] = React.useState([]);
    const [listF, setListF] = React.useState([]);


    React.useEffect(() => {
        if (open) {
            buscaAPI();
        }
    }, [open])

    const handleClose = () => {
        onClose();
    };
    function handleCellClick(row){
        console.log( row );

        console.log( code );
        const dado = {
            api: row.nome,
            code: code
        }
        Service.POST("/api/security/model/codeApi", dado).then(r =>{
            console.log( r );
            if( r.success){
                setCode( r.dado);
                handleClose();
            }else{
                alert(r.msg)
            }

            handleClose();
        })
    }
    function buscaAPI() {
        Service.GET("/api/bpmn/buscaTodosOnLine").then(r => {
            if (r && r.length > 0) {
                setListAPI(r);
                setListF(r);
            }
        }).catch(er => {
            console.log(er)
        });
    }
    return (
        <Dialog
            onClose={handleClose}
            open={open}>
            <DialogTitle>
                <SearchField className="pd-float-dir" />
            </DialogTitle>

            <List sx={{ 
                    width: '100%', 
                    maxWidth: 460, 
                    bgcolor: 'background.paper',
                    position: 'relative',
                    overflow: 'auto',
                    maxHeight: 300,
                    '& ul': { padding: 0 },
                }}>
                {listF.map((row, id)=>(
                    <ListItemButton key={id} alignItems="flex-start" onClick={()=> handleCellClick(row)}>
                        <ListItemText
                            primary={row.nome}
                            secondary={
                                <React.Fragment>
                                  <Typography
                                    component="span"
                                    variant="body2"
                                    sx={{ color: 'text.primary', display: 'inline' }}
                                  >
                                    {row.pacote?row.pacote:'sem.pacote'}
                                  </Typography>
                                  {" — "+row.descricao}
                                </React.Fragment>
                              }
                        />
                    </ListItemButton>
                ))}
                
            </List>

        </Dialog>
    )
}